// removed by extract-text-webpack-plugin
module.exports = {"list":"list__3jolP","review":"review__Hc3lc"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/customerReviews.scss
// module id = 749
// module chunks = 68